<template>
  <a-card :bordered="false">
    <div class="bonus-manage">
      <div>
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="评论状态:">
                <a-select
                  default-value="评论状态"
                  placeholder="请选择状态"
                  v-model="queryParam.status"
                  style="width: 220px"
                >
                  <a-select-option value="0"> 未审核 </a-select-option>
                  <a-select-option value="2"> 已审核 </a-select-option>
                  <a-select-option value="1"> 已驳回 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div>
        <a-table
          ref="tableSelect"
          :columns="columns"
          :scroll="{ x: 1300 }"
          rowKey="id"
          bordered
          :data-source="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :pagination="ipagination"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <template slot="status" slot-scope="text">
            <span v-if="text == 0">未审核</span>
            <span v-if="text == 1">审核驳回</span>
            <span v-if="text == 2">审核通过</span>
            <span v-if="text == 3">已删除</span>
          </template>
          <template slot="profile" slot-scope="text, record">
            <img
              :src="record.profile"
              alt=""
              style="width: 80px; height: 40px"
            />
          </template>

          <!-- <template slot="action">
      <a-button @click="checkHandleOk('1')">审核驳回</a-button>
      <a-button type="primary" @click="checkHandleOk('2')">审核通过</a-button>

    </template>-->
          <span slot="action" slot-scope="text, record">
            <span v-if="record.status == '0'">
              <a
                @click="
                  checkHandleOk('2', record.id, record.openId, record.profile)
                "
                >通过</a
              >&nbsp;&nbsp;
              <a @click="checkHandleOk('1', record.id)">驳回</a>&nbsp;&nbsp;
              <!--<a @click="checkHandleOk('3',record.id)">撤销</a-->
            </span>
            <span v-else-if="record.status == '2'">
              <a href="javascript:;" @click="editIcon(record, record.id)"
                >评论</a
              >&nbsp;
              <a @click="checkHandleOk('3', record.id)">撤销</a>
            </span>
            <span v-else-if="record.status == '1'">
              <a @click="checkHandleOk('3', record.id)">撤销</a>&nbsp;&nbsp;
            </span>
          </span>
        </a-table>
      </div>
      <a-modal v-model="editVisible" title="评论(限300字内)" @ok="editHandleOk">
        <a-form-model
          ref="editRuleForm"
          :model="editForm"
          :rules="editRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="评论：" prop="title">
            <a-input
              :max-length="50"
              v-model="editForm.speechContent"
              style="width: 300px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </a-card>
</template>
<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, postAction } from '@/api/manage';

const columns = [
  {
    title: '留言人',
    dataIndex: 'spokesMan',
    key: 'spokesMan',
    width: 80,
  },
  {
    title: '头像',
    dataIndex: 'profile',
    key: 'profile',
    scopedSlots: { customRender: 'profile' },
  },

  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
  {
    title: '评论内容',
    dataIndex: 'speechContent',
    key: 'speechContent',
    ellipsis: true,
    width: 200,
  },
  {
    title: '回复人',
    dataIndex: 'replierMan',
    key: 'replierMan',
  },
  ,
  /*{
      title: '回复内容',
      dataIndex: 'replyContent',
      ellipsis: true,
      width: 200,
    //  maxlength
      key: 'replyContent',
    }*/ {
    title: '被回复人',
    dataIndex: 'byReplyMan',
    key: 'byReplyMan',
  },
  {
    title: '点赞数量',
    dataIndex: 'praiseNum',
    key: 'praiseNum',
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: {
      customRender: 'status',
    },
  },
  {
    title: '发布时间',
    dataIndex: 'publishTime',
    key: 'publishTime',
    width: 140,
  },
  {
    title: '操作',
    fixed: 'right',
    width: 100,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: 'commentManage',
  mixins: [JeecgListMixin, mixinDevice],

  data() {
    return {
      labelCol: { span: 5 },
      editForm: {},
      visible: true,
      wrapperCol: { span: 14 },
      editRules: {},
      editVisible: false,
      columns,
      selectedRowKeys: [],
      share_type: [],
      allot_type: [],
      fundList: [],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/comment/list',
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/comment/saveComment',
        audit: process.env.VUE_APP_CMS_CONTENT + '/cont/comment/audit',
        saveintegra:
          process.env.VUE_APP_CMS_MARKETING + '/integral/record/saveintegra',
      },
    };
  },
  created() {
    // this.initData()
  },
  methods: {
    editIcon(record) {
      //  this.record.replyContent =null;
      this.editVisible = true;
      this.editForm = { ...record };
      this.editForm.speechContent = '';
      console.log(this.editForm);
    },

    handleClose() {
      this.visible = false;
    },
    // 点击确认评论按钮时触发
    editHandleOk() {
      this.$refs.editRuleForm.validate((bool) => {
        if (!bool) return;
        postAction(this.url.add, this.editForm).then((res) => {
          if (res.success) {
            this.$message.success('评论成功');
            this.loadData();
            console.log(this.editForm);
          }
        });
        this.editVisible = false;
      });
    },

    checkHandleOk(opt, id, openId, profile) {
      getAction(this.url.audit, { ids: id, opt: opt }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.loadData();
          if ('2' == opt && profile != null) {
            this.handlePublish(id, openId);
          }
        }
      });
    },
    handlePublish(id, openId) {
      let params = {
        id,
        openId,
      };

      this.$http
        .post(this.url.saveintegra, params, {
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
        })
        .then((res) => {
          if (res.success) {
            let { result } = res;
            console.log(result);
          } else {
            this.$message.warning(res.message);
          }
        });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
